import React from "react";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
  Input,
  FilledInput,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
function PasswordField({
  id,
  label,
  error,
  size,
  showPassword,
  handleShowPassword,
  handleChangePassword,
  helperText,
  fullWidth,
  labelWidth,
  type,
  ...props
}) {
  return (
    <FormControl fullWidth={fullWidth} size={size} variant="outlined">
      <InputLabel htmlFor="outlined-adornment-password" error={error}>
        {label}
      </InputLabel>
      <OutlinedInput
        id={id}
        label={label}
        type={showPassword ? "text" : "password"}
        onChange={handleChangePassword}
        autoComplete="off"
        variant="outlined"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleShowPassword}
              edge="end"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
        // labelWidth={labelWidth ? labelWidth : 70}
        error={error}
        {...props}
      />

      <FormHelperText id={`fh_${id}`} error={error}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}
export default PasswordField;
